import { createSlice } from '@reduxjs/toolkit';
import { userMessagesApi } from '@/store/api/userMessagesApi';

interface UserMessageState {
  unreadCount: number;
}

const initialState: UserMessageState = {
  unreadCount: 0,
};

export const userMessageSlice = createSlice({
  name: 'userMessage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      userMessagesApi.endpoints.getUnreadMessageCount.matchFulfilled,
      (state, { payload }) => {
        state.unreadCount = payload.data.count ?? 0;
      }
    );
  },
});

export default userMessageSlice.reducer;
